exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".order-appeal-list-tabs[data-v-5a487c6f] .el-tabs__header{margin:0 0 12px}.order-appeal-list-tabs[data-v-5a487c6f] .el-tabs__content{display:none}", "", {"version":3,"sources":["/workspace/src/views/order/components/OrderAppealListTabs.vue"],"names":[],"mappings":"AACA,0DAA0D,eAAe,CACxE,AACD,2DAA2D,YAAY,CACtE","file":"OrderAppealListTabs.vue","sourcesContent":["\n.order-appeal-list-tabs[data-v-5a487c6f] .el-tabs__header{margin:0 0 12px\n}\n.order-appeal-list-tabs[data-v-5a487c6f] .el-tabs__content{display:none\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5a487c6f","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/order/components/OrderAppealListTabs.vue
// module id = 2377
// module chunks = 192 223